import type { HeroFragment } from '@graphqlTypes';

type SlideRow = NonNullable<NonNullable<HeroFragment['slides']>[number]>;

export type SlideData = {
  image?: SlideRow['image'];
  video?: SlideRow['video'];
  videoThumbnail?: SlideRow['videoThumbnail'];
  assetType?: SlideRow['assetType'];
  layeredAnimate?: HeroFragment['layeredAnimate'];
  disableOverlay?: SlideRow['disableOverlay'];
  headline?: SlideRow['headline'];
  mobileHeadline?: SlideRow['mobileHeadline'];
  headlineSize?: SlideRow['headlineSize'];
  bodySize?: SlideRow['bodySize'];
  eyebrow?: SlideRow['eyebrow'];
  body?: SlideRow['body'];
  logo?: SlideRow['logo'];
  contentType?: SlideRow['contentType'];
  showReverb?: SlideRow['showReverb'];
  linkHero?: SlideRow['linkHero'];
  heroLink?: Omit<NonNullable<SlideRow['heroLink']>, '__typename'>;
  customCursorText?: SlideRow['customCursorText'];
};

// Slides may also be built by hand, e.g. the ceremony template's single-slide heroes.
export type HeroProps = Omit<HeroFragment, '__typename' | 'slides'> & {
  slides?: Array<SlideData | null> | null;
};

function toSlideData(s: SlideData): SlideData {
  return {
    image: s.image,
    video: s.video,
    videoThumbnail: s.videoThumbnail,
    assetType: s.assetType,
    disableOverlay: s.disableOverlay,
    headline: s.headline,
    mobileHeadline: s.mobileHeadline,
    headlineSize: s.headlineSize,
    bodySize: s.bodySize,
    eyebrow: s.eyebrow,
    body: s.body,
    logo: s.logo,
    contentType: s.contentType,
    showReverb: s.showReverb,
    linkHero: s.linkHero,
    heroLink: s.heroLink ?? undefined,
    customCursorText: s.customCursorText,
  };
}

export function buildHeroSlides(props: HeroProps): SlideData[] {
  // Layered animation is a hero-level setting and only supported on the first slide.
  return (props.slides ?? []).filter(Boolean).map((s, index) => ({
    ...toSlideData(s!),
    layeredAnimate: index === 0 ? props.layeredAnimate : false,
  }));
}
